import getScenarioStore from '../store/getScenarioStore';
import { SearchScenarioId } from 'owa-search-next-common';

export default function getSearchSessionGuid(scenarioId: SearchScenarioId): string {
    return getScenarioStore(scenarioId).searchSessionGuid;
}
